import { createContext, useContext } from 'react';

const AppHeaderContext = createContext(null);

export function useAppHeader() {
  return useContext(AppHeaderContext);
}

export { AppHeaderContext };
